import React from "react";
import Panel from "../../../components/panels/panel";
import AddressRow from "./AddressRow";
import ContactRow from "./ContactRow";
import VatRow from "./VatRow";

interface Props {
  billingDetails: server.dto.ClientBillingDetails
}

const BillingDetailsPanel = (props: Props) => {
  return <Panel
    title={RESX.Subscription.BillingDetails}
    articleId={serverReference.supportArticleIds.changeMyBillingDetails}
    panelClassName="s1_options-panel"
  >
    <div className="content-section">
      <AddressRow billingDetails={props.billingDetails} />
      <ContactRow billingDetails={props.billingDetails} />
      <VatRow billingDetails={props.billingDetails} />
    </div>
  </Panel>;
};

export default BillingDetailsPanel;
